import api from '@/utils/api';
import { isCorporateMockEnabled } from './environment';
import store from '@/store';

export function useMock() {
    // Sempre endpoints reais `/corporate/*` (mock desativado).
    return false;
}

export function authHeaders(accessToken) {
    const token = accessToken || store.state?.token;
    return {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
    };
}

export async function corporateGet(path, accessToken, params = {}) {
    const response = await api.get(path, {
        headers: authHeaders(accessToken),
        params,
    });
    return response.data;
}

export async function corporatePost(path, payload, accessToken) {
    const response = await api.post(path, payload, {
        headers: authHeaders(accessToken),
    });
    if (!response) {
        const error = new Error('Resposta vazia da API.');
        error.code = 'EMPTY_RESPONSE';
        throw error;
    }
    return response.data;
}

export async function corporatePut(path, payload, accessToken) {
    const response = await api.put(path, payload, {
        headers: authHeaders(accessToken),
    });
    if (!response) {
        const error = new Error('Resposta vazia da API.');
        error.code = 'EMPTY_RESPONSE';
        throw error;
    }
    return response.data;
}

export async function corporatePatch(path, payload, accessToken) {
    const response = await api.patch(path, payload, {
        headers: authHeaders(accessToken),
    });
    return response.data;
}

export async function corporateDelete(path, accessToken) {
    const response = await api.delete(path, {
        headers: authHeaders(accessToken),
    });
    return response.data;
}
